import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import { Menu, Icon, Row, Col } from 'antd';
import { connect } from 'react-redux';
import userStorage from '../../../utils/storage';
import './Aside.less';
const SubMenu = Menu.SubMenu;
class Aside extends PureComponent {
  constructor() {
    super();
    this.state = {};
    this.logout = this.logout.bind(this);
  }
  componentDidMount() {}
  logout() {
    userStorage.clear();
    this.props.history.push('/login');
  }
  render() {
    const { menu, asideHighlight, headHighlight } = this.props;
    const asideHighlightString = asideHighlight.map(item =>
      item.value.toString()
    );
    const username =
      localStorage.userInfo && JSON.parse(localStorage.userInfo).username;
    const headHighlightId = headHighlight[0] ? headHighlight[0].value : '';
    return (
      <div className="aside">
        <Row className="aside-user" type="flex" justify="space-between">
          <Col>
            <Icon type="user" />
            {username}
          </Col>
          <Col>
            <span onClick={this.logout}>退出</span>
          </Col>
        </Row>

        <Menu selectedKeys={asideHighlightString} mode="inline" theme="dark">
          {menu.map(it => {
            if (it.key === headHighlightId) {
              return (
                it.children &&
                it.children.map(item => {
                  return item.children ? (
                    <SubMenu
                      key={item.key}
                      title={
                        <span>
                          {item.icon && <Icon type={item.icon} />}
                          <span>{item.title}</span>
                        </span>
                      }
                    >
                      {item.children.map(item => {
                        return (
                          <Menu.Item key={item.key}>
                            <Link to={item.url}>{item.title}</Link>
                          </Menu.Item>
                        );
                      })}
                    </SubMenu>
                  ) : (
                    <Menu.Item key={item.key}>
                      <Link to={item.url}>{item.title}</Link>
                    </Menu.Item>
                  );
                })
              );
            }
          })}
        </Menu>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    ...state.menu
  };
}
export default connect(mapStateToProps)(Aside);
